import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import Button from './Button';

const Header = () => {
  const location = useLocation();
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      await signOut();
      navigate('/signin');
    } catch (error) {
      console.error('Sign out error:', error);
    }
  };

  const navItems = [
    { label: 'Dashboard', route: '/home-dashboard', icon: 'Home' },
    { label: 'Setup', route: '/location-input', icon: 'MapPin' },
    { label: 'Results', route: '/meeting-point-results', icon: 'Target' },
    { label: 'Refine', route: '/location-type-filter', icon: 'Filter' },
    { label: 'Finalize', route: '/final-meeting-details', icon: 'CheckCircle' },
    { label: 'Active', route: '/active-meeting', icon: 'Navigation' },
    { label: 'Invites', route: '/invitation-status', icon: 'Users' }
  ];

  const isActive = (route) => location?.pathname === route;

  return (
    <header className="sticky top-0 z-[100] bg-card border-b border-border shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link 
            to="/" 
            className="flex items-center gap-3 transition-smooth hover-lift active-press focus:outline-none focus:ring-3 focus:ring-ring focus:ring-offset-3 rounded-lg"
          >
            <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg">
              <Icon name="MapPin" size={24} className="text-primary" />
            </div>
            <div className="hidden sm:block">
              <h1 className="font-heading text-xl font-semibold text-foreground">
                Mosey
              </h1>
              <p className="caption text-muted-foreground -mt-1">
                Fair meeting coordination
              </p>
            </div>
          </Link>

          <nav className="hidden md:flex items-center gap-1" aria-label="Main navigation">
            {navItems?.map((item) => (
              <Link
                key={item?.route}
                to={item?.route}
                className={`
                  flex items-center gap-2 px-4 py-2 rounded-lg font-medium text-sm
                  transition-smooth hover-lift active-press
                  focus:outline-none focus:ring-3 focus:ring-ring focus:ring-offset-3
                  ${isActive(item?.route)
                    ? 'bg-primary text-primary-foreground'
                    : 'text-muted-foreground hover:text-foreground hover:bg-muted'
                  }
                `}
                aria-current={isActive(item?.route) ? 'page' : undefined}
              >
                <Icon name={item?.icon} size={18} />
                <span>{item?.label}</span>
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <button
              className="p-2 rounded-lg text-muted-foreground hover:text-foreground hover:bg-muted transition-smooth active-press focus:outline-none focus:ring-3 focus:ring-ring focus:ring-offset-3"
              aria-label="Help"
            >
              <Icon name="HelpCircle" size={20} />
            </button>
            <button
              onClick={() => navigate('/notification-settings')}
              className="p-2 rounded-lg text-muted-foreground hover:text-foreground hover:bg-muted transition-smooth active-press focus:outline-none focus:ring-3 focus:ring-ring focus:ring-offset-3"
              aria-label="Settings"
            >
              <Icon name="Settings" size={20} />
            </button>
            {user && (
              <div className="flex items-center gap-4">
                <div className="hidden sm:flex items-center gap-2">
                  <Icon name="User" size={16} className="text-muted-foreground" />
                  <span className="text-sm text-muted-foreground">
                    {user?.email}
                  </span>
                </div>
                <Button
                  variant="outline"
                  size="sm"
                  iconName="LogOut"
                  iconPosition="left"
                  onClick={handleSignOut}
                >
                  Sign Out
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;